import TagPedagioResponse from '../entities/TagPedagioResponse'
import ITagPedagioRepository from '../repositories/ITagPedagioRepository'

export interface IFindAll {
  execute(): Promise<TagPedagioResponse>
}

export default class FindAllImpl implements IFindAll {
  constructor(private readonly tagPedagioRepository: ITagPedagioRepository) {}

  public async execute(): Promise<TagPedagioResponse> {
    const response = await this.tagPedagioRepository.findAll()
    return response
  }
}
